<template>
  <base-layout @handleScroll="handleScroll">
    <v-row
      no-gutters
      justify="space-between"
      class="pt-3">
      <v-col
        md="4"
        cols="12"
        class="d-flex align-center select-branch">
      </v-col>
      <v-col
        md="6"
        cols="12"
        class="d-flex align-center search-product">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              label="Search"
              dense
              append-icon="mdi-magnify"
              @input="searchOrders(true)" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <OrderList
          :orders="orders"
          @onSortItem="sortOrder" />
      </v-col>
    </v-row>
  </base-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import OrderProvider from '@/resources/order.service'
import orderList from '../components/order-list.vue'

const orderService = new OrderProvider()

export default {
  components: {
    OrderList: orderList
  },
  data () {
    return {
      search: '',
      orders: [],
      perPage: 15,
      page: 1,
      loading: true,
      getting: false,
      isLoadComplete: false
    }
  },
  computed: {
    ...mapGetters({
      warehouse: 'Warehouse/warehouse',
      selectedWarehouse: 'Warehouse/selectedWarehouse'
    })
  },
  watch: {
    selectedWarehouse () {
      this.searchOrders()
    }
  },
  async created () {
    await this.loadOrders()
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setLoading: 'Style/setLoading'
    }),
    sortOrder (sortVal) {
      this.isLoadComplete = false
      this.page = 1
      this.orders = []
      this.loadOrders(sortVal.val, sortVal.order)
    },
    searchOrders (isWait = false) {
      if (isWait) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.isLoadComplete = false
          this.page = 1
          this.orders = []
          this.loadOrders()
        }, 1500)
      } else {
        this.isLoadComplete = false
        this.page = 1
        this.orders = []
        this.loadOrders()
      }
    },
    handleScroll (e) {
      const scrollY = e.scrollHeight - e.clientHeight - 500
      if (e.scrollTop >= scrollY && !this.getting) {
        this.loadOrders()
      }
    },
    async loadOrders (sortBy = 'create_time', sortOrder = 'desc') {
      if (this.getting || this.isLoadComplete) {
        return
      }
      this.getting = true
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'Getting Orders.'
        })
        const { data } = await orderService.getBills(this.page++, this.perPage, this.search, this.selectedWarehouse, sortBy, sortOrder)
        if (data.length < this.perPage) {
          this.isLoadComplete = true
        }
        this.orders.push(...data)
      } catch (error) {
        this.setSnackBar({
          value: true,
          message: 'Something went wrong.',
          type: 'error'
        })
      } finally {
        this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting Orders.'
        })
      }
      this.getting = false
    }
  }
}
</script>
